import { orderedAppBreakpoints } from '../../common/constants/breakpoints';

export function deriveAppBreakpointFromWindow() {
  const { innerWidth } = window;
  return orderedAppBreakpoints.find((b) => innerWidth >= b);
}
